<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <label class="input-wrapp relative block">
      <input
        :type="type"
        class="block h-16 md:h-[72px] w-full text-base text-current font-medium px-8 input-border focus-visible:!border-current !outline-none duration-200"
        :name="name"
        placeholder=" "
        :autocomplete="autocomplete"
        :value="value"
        @input="inputChange"
      />
      <span
        class="block absolute pointer-events-none whitespace-nowrap opacity-50 top-1/2 left-8 -translate-y-1/2 duration-200 will-change-transform"
        v-text="placeholder"
      ></span>
    </label>
    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'simpleInput',
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: String,
    required: {
      type: Boolean,
      default: false,
    },
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
  },

  methods: {
    inputChange(e) {
      this.$emit('input', e.target.value)
    },
  },
}
</script>
